import axios from 'axios';

const BASE_URL = 'https://pixabay.com/api/';
const API_KEY = '55309008-edb7c4bb1c6dba6c84cf593ac';

export function getImagesByQuery(query) {
  const params = new URLSearchParams({
    key: API_KEY,
    q: query,
    image_type: 'photo',
    orientation: 'horizontal',
    safesearch: true,
  });

  return axios.get(`${BASE_URL}?${params}`).then(response => response.data);
}
